/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import { ReactNode } from 'react'

import { useRouter } from 'next/router'
import { IntlProvider } from 'react-intl'


import viVN from 'translations/vi.json' // DO NOT REMOVE COMMENT - trim key: vi-VN


const englishSites = [
  'en-diabetes',
  'en-weight-management',
  'bmi-calculator-en',
]

export type Props = {
  children?: ReactNode
}

const IntlMessages: Record<string, any> = {
  
  'vi-VN': viVN,
  
}
export const DynamicIntlWrapper = ({ children }: Props) => {
  const { locale = 'en-PH', defaultLocale, query } = useRouter()

  const messagesLocale =
    locale === 'hi-IN' &&
    englishSites.some((site) => query?.slug?.includes(site))
      ? 'en-PH'
      : locale
  const messages = IntlMessages[messagesLocale]
  return (
    <IntlProvider
      locale={locale || defaultLocale || 'en-PH'}
      messages={messages}
      defaultLocale="en-PH"
    >
      {children}
    </IntlProvider>
  )
}
